<template>
    <div v-if="$store.state.openid != ''">
        <top-bar>
            <div class="title">
                  我的客服
            </div>
        </top-bar>
        <div class="company">
                <span>企业：</span>
                <span>{{ info.companyName }}</span>
        </div>
        <ul class="userinfo" v-if="info">
            <van-divider />
            <li>
                <p>您的项目负责人联系方式如下：</p>
                <template v-if="info.info.length" >
                    <div v-for="(item,i) in info.info" :key="i">
                        <div class="info">
                            <span>姓名：</span>
                            <span>{{item.name}}</span>
                        </div>
                        <div class="info">
                            <span>电话：</span>
                            <span>{{item.phone}}</span>
                        </div>
                    </div>
                </template>
                <template v-else>
                    <p style="color:rgb(0, 195, 255)">暂时没有客服信息</p>
                </template>
            </li>
            <div>
                <van-divider />
            <pre>
        以上，为您所在项目的负责人及联系方式。
    如有任何工作方面的问题，可直接联系项目  负责人。
    祝：天天开心，工作顺利~！
            </pre>
        </div>
        </ul>
        <err msg="客服信息未查询到" v-else />
        <van-dialog v-model="show" title="提示" @confirm="confirm">
            <div class="cont">点击进行实名验证</div>
        </van-dialog>
    </div>
</template>

<script>
import Vue from 'vue'
import TopBar from "@/components/Top";
import err from "./err";
import { getOpenId,getHttpAction } from "@/http/salary";
import { init,GetQueryString } from '@/utils/getOpenId'
import { Divider } from 'vant';

Vue.use(Divider);


export default {
    components: {
        TopBar,
        err,
    },
    data() {
        return {
            salaryList: [],
            info:{
                info:[]
            },
            openid:'',
            show: false,
        };
    },
    computed: {},
    created() {
        this.$cookies.set('history','service',60 * 60 * 1)
        if(this.$store.state.openid == ''){
            let openid = this.$route.query.openId
            this.$store.dispatch('SAVEUSERACTION',openid)
        }
        this.getSalary();

        // if(this.$store.state.openid == ''){
        //     this.$cookies.set('history','service',60 * 60 * 1)
        //     let url = encodeURI('http://testwx-platform.engma.net/#/service')
        //     window.location.href=`https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx815dbde2374f3068&response_type=code&scope=snsapi_base&redirect_uri=${url}&state=service#wechat_redirect`
        // }else{
        //     this.openid =  this.init()
        //     this.getSalary();
        // }
    },
    methods: {
        async init(){
            let _this = this
            const res = await getOpenId("/wxAuth/codeToOpenid",{code:GetQueryString('code')});
            if(res.msg == 'success'){
                _this.$store.dispatch('SAVEUSERACTION',res.data)
                return res.data
            }
        },
        async getSalary(payday = this.day) {
            const res = await getHttpAction('/front/customerservice/info')
            if(res.msg == 'success'){
                this.info = res.customerService
            }else if(res.msg == '您还没有实名认证'){
                this.show = true
            }
        },
        confirm(){
            this.$cookies.set('history','service',60 * 60 * 1)
            this.$router.push('./Certification')
        }
    },
};
</script>

<style lang="less" scoped>
.title {
    width: 100%;
    height: 100%;
    display: flex;
    font-weight: 700;
    align-items: center;
    justify-content: center;
}
.company{
    padding: 20px 40px 0 40px;
}
.userinfo {
    width: 100%;
    align-items: center;
    padding: 20px;
    li {
        list-style: none;
        margin: 20px 0;
        padding: 0 20px;
        .info{
            span{
                display: inline-block;
                margin: 10px;
            }
        }
        div {
            font-weight: 600;
            font-size: 14px;
            display: inline-block;
            min-width: 100px;
            text-align-last: right;
        }
    }
}
.cont{
    text-align: center;
    padding: 20px;
}
</style>
